// 個別機能訓練に関する記録・詳細.
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as Header from '../constants/Header';
import * as UserListField from '../constants/UserListField';
import * as moment from 'moment';
import { Male, Female } from '../constants/UserListField';
import { formatBirthday } from '../utils/dateUtil';
import KirokuShow, { DummyKirokuShow } from './KirokuShow';
import KirokuEdit from './KirokuEdit';
import * as KirokuConst from '../constants/Kiroku';
import { JS_VOID } from '../utils/commonUtil';
import '../css/print_kiroku.css';

interface KirokuProps extends React.Props<{}> {
  headerActions?: any;
  moffAPIActions: any;

  // 前ページのユーザーID.
  match?: any;
  moffAPI: any;
}

interface KirokuState {
  startDate: string;
  endDate: string;

  // Show/Edit.
  type: KirokuConst.type;
}

// 詳細本体.
export default class Kiroku extends React.Component<KirokuProps, KirokuState> {

  static get childContextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  user: UserListField.User;
  filteredTraining: KirokuConst.Training[];
  userId: string;

  constructor(props: KirokuProps) {
    super(props);

    // 開始(月初) YYYY-MM-DD
    let startYearMonthDay: string = moment().startOf('month').format('YYYY-MM-DD'); 
    // 終わり(月末) YYYY-MM-DD
    let endYearMonthDay: string = moment().endOf('month').format('YYYY-MM-DD'); 

    this.state = {
      type: KirokuConst.type.Show,
      // 開始と終わり.
      startDate: startYearMonthDay,
      endDate: endYearMonthDay,
    };
  }

  // 子のMonthlyHistoryコンポーネントから呼ばれるcontext管理.
  getChildContext() {
    const callback: Function = (type: KirokuConst.type) => {
      this.setState({
        type: type,
      });
    };

    return {
      callbackParent: callback,
    };
  }

  // 範囲内でAPIを叩く.
  runAPI(startDate: string, endDate: string) {
    // URLのパラメータ.
    const userId = this.userId;

    // 個別機能訓練に関する記録・詳細 3つを同時.
    // getTraining()
    // getUser(userId)
    // getFunctionalTrainingHistory(userId, '2018-02-01', '2018-02-10');
    this.props.moffAPIActions.getTrainingDetailData([
      null,
      userId,
      [userId, startDate, endDate]
    ]);
  }

  componentWillMount() {
    // URLのパラメータ.
    this.userId = this.props.match.params.userId;

    document.title = '記録一覧(曜日別)';
  
    this.props.headerActions.setPage(Header.KIROKU);
  
    this.user = {
      user_care_id: '',
      user_name: '',
      user_birth_year: '',
      user_gender: 1
    } as UserListField.User;

    // 最初に一回通信.
    this.runAPI(this.state.startDate, this.state.endDate);
  }

  shouldComponentUpdate(nextProps: KirokuProps, nextState: KirokuState) {
    if (this.state.type !== nextState.type) {
      // 変化したら一覧取得の通信.
      this.runAPI(this.state.startDate, this.state.endDate);
    }

    return true;
  }

  componentWillReceiveProps() {
    // propsが変わった時に変化.
    if (this.props.moffAPI.Loaded && this.state.type === KirokuConst.type.Delete) {
      alert('データを削除しました');

      this.setState({
        type: KirokuConst.type.Show,
      });
    }
  }

  toKirokuEdit() {
    this.setState(
      {type: 1}
    );
  }

  render() {
    let isApp: boolean = false;

    let className: string = 'report kiroku_tpl';
    if (this.state.type === KirokuConst.type.Edit) {
      className += ' kiroku_edit_tpl';
    }

    return (
      <div>
        <style type="text/css">
          {/* 縦印刷, 日付・title名ヘッダの余白 */}
          {'@media print{@page {size: portrait; margin-top: 43px;}}'}
          {'@media print{#wrapper { padding:0; margin: 0; } header { display: none; }}'}
          {'@media print{.contentIn { padding-top:0!important; padding-bottom:0!important; }}'}
          {'@media print{.report { padding-bottom:0!important; }}'}
          {/* Edge対策 */}
          {'@media print{tr { page-break-inside: avoid; }}'}
        </style>
        { // ロード済み.
          (() => {
            if (this.props.moffAPI.Loaded) {
              // キャッシュさせておく.
              if (this.props.moffAPI.result.training) {
                this.filteredTraining = this.props.moffAPI.result.filteredTraining;
              }

              if (this.props.moffAPI.result.user) {
                this.user = this.props.moffAPI.result.user;
              }

              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }

        <article className={className}>
          <div className="user hideable">
            <p>{this.user.user_care_id}</p>
            <p>{this.user.user_name}</p>
            <p>{this.user.user_birth_year}</p>
            <p>{this.user.user_gender ? '女' : '男'}</p>
          </div>

          { isApp ? (null) :
            <div className="print-btn btnStyle00">
              <a
                href={JS_VOID}
                onClick={_ => {window.print(); return false; }}
                className=""
                role="button"
              >
                印刷する  
              </a>
            </div>
          }
          <section id="sec02">
            <h2 className="ttlStyle01">個別機能訓練に関する記録</h2>
            <div className="inner">
              <div className="calendarHeader">
                <div className="dateArea">
                  <p>氏名</p>
                  <p className="userName">
                    {this.user.user_name} 様{'　'}
                    <span className="userBirthday">
                      {formatBirthday(this.user.user_birth_year, this.user.user_birth_month, this.user.user_birth_day)}
                      {'　'}
                      {this.getGender(this.user.user_gender)}
                    </span>
                  </p>
                  {/* <>矢印と日付 */}
                  <div id="kirokuYearDate" className="date">
                    {moment(this.state.startDate).format('YYYY')}
                    <span>年</span>
                    {moment(this.state.startDate).format('MM')}
                    <span>月</span>
                  </div>
                  <div id="kirokuArrowL" className="btn left">
                    <a href={JS_VOID} onClick={_ => this.handlePushArrow(-1)} />
                  </div>
                  <div id="kirokuArrowR" className="btn right">
                    <a href={JS_VOID} onClick={_ => this.handlePushArrow(1)} />
                  </div>
                </div>
              </div>
              {
                (() => {
                  switch (this.state.type) {
                    case KirokuConst.type.Show:
                      if (this.props.moffAPI.Loaded) {
                        return <KirokuShow
                          moffAPI={this.props.moffAPI}
                          moffAPIActions={this.props.moffAPIActions}
                          user={this.user}
                          filteredTraining={this.filteredTraining}
                        />;
                      }

                      // ダミー.
                      return <DummyKirokuShow />;
                    case KirokuConst.type.Edit:
                      return <KirokuEdit
                        moffAPI={this.props.moffAPI}
                        moffAPIActions={this.props.moffAPIActions}
                        user={this.user}
                      />;
                    default:
                      return (null);
                  }
                })()
              }
            </div>
          </section>
        </article>
      </div>
    );
  }

  /**
   * State変更とAPI呼び出し.
   *
   * @private
   * @memberof Kiroku
   */
  private changeStateAndCallAPI = (startDate: string, endDate: string) => {
    this.setState(
      {
        startDate: startDate,
        endDate: endDate,
      }
    );

    // 通信.
    this.runAPI(startDate, endDate);
  }

  /**
   * 矢印の押下時の処理.
   *
   * @private
   * @param {number} appendMonth 追加する月.
   * @memberof Kiroku
   */
  private handlePushArrow(appendMonth: number) {
    const startDate: string = this.state.startDate;
    const endDate: string = this.state.endDate;
    // 月初.
    const changedStartDate = moment(startDate).add('months', appendMonth).startOf('month').format('YYYY-MM-DD');
    // 月末.
    const changedEndDate = moment(endDate).add('months', appendMonth).endOf('month').format('YYYY-MM-DD');

    this.changeStateAndCallAPI(changedStartDate, changedEndDate);
  }

  /**
   * 男性、女性表示.
   *
   * @param {number} gender
   * @returns {string}
   * @memberof MoffCheck
   */
  private getGender(gender: number): string {
    return `${gender === 0 ? Male : Female}性`;
  }
}



// WEBPACK FOOTER //
// ./src/components/Kiroku.tsx